"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wrapPromiseInTimeoutWithRetries = exports.wrapPromiseInTimeout = void 0;
const commons_logs_1 = require("@deliverr/commons-logs");
const errors_1 = require("@deliverr/errors");
async function wrapPromiseInTimeout(orgPromise, timeoutInMs, timeoutError) {
    if (!timeoutError) {
        timeoutError = new errors_1.DeliverrError("Call timed out");
    }
    const timeoutPromise = new Promise((_resolve, reject) => setTimeout(() => {
        reject(timeoutError);
    }, timeoutInMs));
    return Promise.race([orgPromise, timeoutPromise]).catch((err) => {
        throw err;
    });
}
exports.wrapPromiseInTimeout = wrapPromiseInTimeout;
async function wrapPromiseInTimeoutWithRetries(orgPromiseFactory, timeoutInMs, timeoutError, maxRetries = 0) {
    if (!timeoutError) {
        timeoutError = new errors_1.DeliverrError("Call timed out");
    }
    const createTimeoutPromise = () => new Promise((_resolve, reject) => setTimeout(() => {
        reject(timeoutError);
    }, timeoutInMs));
    const attemptWithTimeout = async (retryCount) => {
        try {
            const result = await Promise.race([orgPromiseFactory(), createTimeoutPromise()]);
            return { result, retryCount };
        }
        catch (err) {
            if (err instanceof errors_1.DeliverrError && timeoutError && err.code === timeoutError.code && retryCount < maxRetries) {
                commons_logs_1.log.warn(`Timeout occurred. Retrying attempt ${retryCount + 1} of ${maxRetries}`);
                return attemptWithTimeout(retryCount + 1);
            }
            throw err;
        }
    };
    return attemptWithTimeout(0);
}
exports.wrapPromiseInTimeoutWithRetries = wrapPromiseInTimeoutWithRetries;
//# sourceMappingURL=PromiseUtils.js.map